import React from 'react'
import { NavLink } from 'react-router-dom'

export const FooterInfo: React.FC = () => {
    return (
        <>
            <div className="text-[20px] text-[#FFFFFF] font-bold text-left">
                Информация
            </div>
            <div className="text-[16px] text-left">
                <p>
                    <NavLink to="/about/us">О нас</NavLink>
                </p>
                {/* <p className="text-[#FFFFFF]">Справочники</p>*/}
                <p className="text-[#FFFFFF]">
                    <NavLink to="/price">Тарифы</NavLink>
                </p>
                <p>
                    <NavLink to="/docs/privacy-policy">
                        Политика конфиденциальности
                    </NavLink>
                </p>
                {/* <p className="text-[#FFFFFF]">Заказать звонок</p> */}
            </div>
        </>
    )
}
